﻿import LfDataService from '../../../Services/LfDataService';

import {
    pageIsLoadingAction, 
    pageLoadedAction, 
    pageCurrentStepAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';

import {
    sortInsurancesByGroupName, 
    sortInsurancesByName, 
    filterRegistrationsIfDraftExists,
    sortByObjectIdAndFilterDrafts
} from '../../../DataHelpers/lfDataHelpers';

export function loadPreregistrationPageDataAction() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        let customerInfo, coinsuredInfo; 

        lfDataService.customerInfo()
            .then(data => {
                customerInfo = data.customerInfo;
                coinsuredInfo = data.currentCoInsured;

                return Promise.all([
                    lfDataService.insurances(),
                    lfDataService.preregistrations()
                ]);
            })
            .then(values => {
                let data = values.reduce((acc, obj) => {
                    Object.keys(obj).forEach(prop => acc[prop] = obj[prop]); 
                    return acc; 
                }, {});

                data.customerInfo = customerInfo;
                data.coinsuredInfo = coinsuredInfo;
                data.insurancesByName = sortInsurancesByName(data.insurances);

                let memberRegistrations = sortInsurancesByGroupName(data.preregistrations.filter(r => !r.appliesToCoinsured && r.targetGroupName !== 'djur'));
                let coRegistrations = sortInsurancesByGroupName(data.preregistrations.filter(r => r.appliesToCoinsured && r.targetGroupName !== 'djur'));
                let animalRegistrations = sortInsurancesByGroupName(data.preregistrations.filter(r => r.targetGroupName === 'djur'));

                data.animalRegistrations = sortByObjectIdAndFilterDrafts(animalRegistrations);
                data.memberRegistrations = memberRegistrations.map(group => filterRegistrationsIfDraftExists(group));
                data.coRegistrations = coRegistrations.map(group => filterRegistrationsIfDraftExists(group));

                dispatch(preregistrationPageLoadedAction(data));
                dispatch(pageIsLoadingAction(false));
                dispatch(pageCurrentStepAction(0));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}

export function preregistrationPageLoadedAction(data) {
    return {
        type: 'INSURANCE_PREREGISTRATIONS_PAGE_LOADED',
        data
    };
}